import { Component, OnInit, ElementRef  } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { CFDI } from "../../../../entities/cdfi";
import { DatosFacturacionService } from "../../../../shared/datos-facturacion.service";


@Component({
  selector: 'app-modal-facturacion',
  templateUrl: './modal-facturacion.component.html',
  styleUrls: ['./modal-facturacion.component.scss']
})
export class ModalFacturacionComponent {
  public facturacionForm: FormGroup;
  public listaCfdi: CFDI[];

  constructor(
    private datosFactService: DatosFacturacionService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.initForm();
    // this.obtnerCFDI();
    this.listaCfdi = [
      {
        id: 1,
        usoCFDI: "G01",
        descripcion: "Adquisición de mercancías",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 2,
        usoCFDI: "G02",
        descripcion: "Devoluciones, descuentos o bonificaciones",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 3,
        usoCFDI: "G03",
        descripcion: "Gastos en general",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 4,
        usoCFDI: "I01",
        descripcion: "Construcciones",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 5,
        usoCFDI: "I02",
        descripcion: "Mobiliario y equipo de oficina por inversiones",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 6,
        usoCFDI: "I03",
        descripcion: "Equipo de transporte",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 7,
        usoCFDI: "I04",
        descripcion: "Equipo de cómputo y accesorios",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 8,
        usoCFDI: "I05",
        descripcion: "Dados, troqueles, moldes, matrices y herramental",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 9,
        usoCFDI: "I06",
        descripcion: "Comunicaciones telefónicas",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 10,
        usoCFDI: "I07",
        descripcion: "Comunicaciones satelitales",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 11,
        usoCFDI: "I08",
        descripcion: "Otra maquinaria y equipo",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 12,
        usoCFDI: "D01",
        descripcion: "Honorarios médicos, dentales y gastos hospitalarios",
        personaFisica: true,
        personaMoral: false,
      },
      {
        id: 13,
        usoCFDI: "D02",
        descripcion: "Gastos médicos por incapacidad o discapacidad",
        personaFisica: true,
        personaMoral: false,
      },
      {
        id: 14,
        usoCFDI: "D03",
        descripcion: "Gastos funerales",
        personaFisica: true,
        personaMoral: false,
      },
      {
        id: 15,
        usoCFDI: "D04",
        descripcion: "Donativos",
        personaFisica: true,
        personaMoral: false,
      },
      {
        id: 16,
        usoCFDI: "D05",
        descripcion:
          "Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)",
        personaFisica: true,
        personaMoral: false,
      },
      {
        id: 17,
        usoCFDI: "D06",
        descripcion: "Aportaciones voluntarias al SAR",
        personaFisica: true,
        personaMoral: false,
      },
      {
        id: 18,
        usoCFDI: "D07",
        descripcion: "Primas por seguros de gastos médicos",
        personaFisica: true,
        personaMoral: false,
      },
      {
        id: 19,
        usoCFDI: "D08",
        descripcion: "Gastos de transportación escolar obligatoria",
        personaFisica: true,
        personaMoral: false,
      },
      {
        id: 20,
        usoCFDI: "D09",
        descripcion:
          "Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones",
        personaFisica: true,
        personaMoral: false,
      },
      {
        id: 21,
        usoCFDI: "D10",
        descripcion: "Pagos por servicios educativos (colegiaturas)",
        personaFisica: true,
        personaMoral: false,
      },
      {
        id: 22,
        usoCFDI: "CP01",
        descripcion: "Pagos",
        personaFisica: true,
        personaMoral: true,
      },
      {
        id: 23,
        usoCFDI: "CN01",
        descripcion: "Nómina",
        personaFisica: true,
        personaMoral: false,
      },
      {
        id: 24,
        usoCFDI: "S01",
        descripcion: "Sin Efectos Fiscales",
        personaFisica: true,
        personaMoral: true,
      },
    ];
    
  }

  initForm() {
    this.facturacionForm = this.fb.group({
      rfc: new FormControl("", [
        Validators.required,
        Validators.pattern(/^(?=.*[a-zA-Z])(?=.*\d).+$/),
        Validators.maxLength(16),
      ]),
      // referencia: new FormControl("", [Validators.required]),
      nombre: new FormControl("", [Validators.required]),
      cp: new FormControl("", [Validators.required]),
      regimenFiscal: new FormControl("", [Validators.required]),
      usoCfdi: new FormControl("", [Validators.required]),
    });
  }

  obtnerCFDI() {
    this.datosFactService.listarCFDI().subscribe(
      (response) => {
        this.listaCfdi = response;
      })
  }

  soloLetrasNumerosExt(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloLetrasNumeros = input.value.replace(/[^a-zA-Z0-9]/g, "");
    this.facturacionForm.patchValue({ rfc: soloLetrasNumeros });
  }
  soloLetrasNumerosEspacios(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloLetrasNumeros = input.value.replace(/[^a-zA-Z0-9\s]/g, ""); // Incluye \s para espacios
    this.facturacionForm.patchValue({ rfc: soloLetrasNumeros });
  }

  soloNumerosDomFisc(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.facturacionForm.patchValue({ cp: soloNumeros });
  }

  soloNumerosRegimenFiscal(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.facturacionForm.patchValue({ regimenFiscal: soloNumeros });
  }

  compareCfdi(c1: CFDI, c2: CFDI): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  compareRf(rf1: CFDI, rf2: CFDI): boolean {
    return rf1 && rf2 ? rf1.id === rf2.id : rf1 === rf2;
  }

  changeCdfi() {
    //console.log('aca');
  }

  guardar(){
    if(this.facturacionForm.invalid) {
      this.facturacionForm.markAllAsTouched();
      this.toastr.error("Debes completar todos los campos");
    } else {
      const control = this.facturacionForm.controls;
      const data = {
         rfc: control.rfc.value,
         nombre: control.nombre.value,
         cp: control.cp.value,
         regimenFiscal: control.regimenFiscal.value.usoCFDI,
         usoCfdi: control.usoCfdi.value.usoCFDI,
      };
      this.datosFactService.guardarDatos(data).subscribe(
        (result: any) => {
          Swal.fire({
            title: "Datos Guardados!",
            text: "Los datos han sido guardados con éxito.",
            icon: "success",
            confirmButtonText: 'Aceptar',
            onClose: () => {
              this.closeModal(true);
            }
          });
        },
        (err) => {
          Swal.fire({
            title: "¡Ops!",
            text: err.error,
            icon: "error",
            confirmButtonText: "Cerrar"
          });
        }
      );

    }

  }

  closeModal(reload: boolean) {
    this.datosFactService.$modal.emit(
      {
        statusModal: false,
        reloadPage: reload
      }
    );
  }
}
